import styled from 'styled-components'

export const ImageRender = styled.img`
    width: 50px;
    height: 50px;
    border-radius: 100%;
`
